import { render, staticRenderFns } from "./CourseLessons.vue?vue&type=template&id=4fb71be4&"
import script from "./CourseLessons.vue?vue&type=script&lang=ts&"
export * from "./CourseLessons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports